(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["custom-main-faq"] && !window.DesignMode) return;
  try {
    
  var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-slider"] && !window.DesignMode) return;
  try {
    
  let slideIndex = 1;
  let timeoutId = 0;
  showSlides(slideIndex);
  setupButtons();
  setupDots();

  function setupButtons() {
    let prevs = document.getElementsByClassName("prev")
    let nexts = document.getElementsByClassName("next")
    for (i = 0; i < prevs.length; i++) {
      prevs[i].addEventListener("click", function(){ plusSlides(-1) });
    }
    for (n = 0; n < prevs.length; n++) {
      nexts[n].addEventListener("click", function(){ plusSlides(1) });
    }
  }

  function setupDots() {
    let dots = document.getElementsByClassName("dot")
    dots[0].addEventListener("click", function(){
      if (slideIndex != 1) {
        currentSlide(1);
      }
    });
    dots[1].addEventListener("click", function(){
      if (slideIndex != 2) {
        currentSlide(2);
      }
    });
  }

  // Next/previous controls
  function plusSlides(n) {
    showSlides(slideIndex += n);
  }

  // Thumbnail image controls
  function currentSlide(n) {
    showSlides(slideIndex = n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("custom-slider-slide");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";

    // Set timeout for autoplay
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      plusSlides(1);
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-crea-faq"] && !window.DesignMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hercules-faq"] && !window.DesignMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
    var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-faq"] && !window.DesignMode) return;
  try {
    
    var headers = document.getElementsByClassName("header");
  var i;

  for (i = 0; i < headers.length; i++) {
    headers[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var content = this.nextElementSibling
      if (content.style.maxHeight) {
        content.style.maxHeight = null
      } else {
        content.style.maxHeight = content.scrollHeight + "px"
      }
      // if (content.classList.contains("active")) {
        // content.classList.remove("active");
      // } else {
        // content.classList.add("active");
      // }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-main-slider"] && !window.DesignMode) return;
  try {
    
  let slideIndex = 1;
  let timeoutId = 0;
  showSlides(slideIndex);
  setupButtons();
  setupDots();

  function setupButtons() {
    let prevs = document.getElementsByClassName("prev")
    let nexts = document.getElementsByClassName("next")
    for (i = 0; i < prevs.length; i++) {
      prevs[i].addEventListener("click", function(){ plusSlides(-1) });
    }
    for (n = 0; n < prevs.length; n++) {
      nexts[n].addEventListener("click", function(){ plusSlides(1) });
    }
  }

  function setupDots() {
    let dots = document.getElementsByClassName("dot")
    dots[0].addEventListener("click", function(){
      if (slideIndex != 1) {
        currentSlide(1);
      }
    });
    dots[1].addEventListener("click", function(){
      if (slideIndex != 2) {
        currentSlide(2);
      }
    });
  }

  // Next/previous controls
  function plusSlides(n) {
    showSlides(slideIndex += n);
  }

  // Thumbnail image controls
  function currentSlide(n) {
    showSlides(slideIndex = n);
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("slider-slide");
    let dots = document.getElementsByClassName("dot");
    if (n > slides.length) {slideIndex = 1}
    if (n < 1) {slideIndex = slides.length}
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[slideIndex-1].style.display = "block";
    dots[slideIndex-1].className += " active";

    // Set timeout for autoplay
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      plusSlides(1);
    }, 5000);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-nutrition-facts"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
  $('.new-nutrition-facts-card-image').click(function(e) {
    // Change Selector Here
    $(this).toggleClass('fullscreen');
  });
});

  } catch(e) { console.error(e); }
})();
      })();
